/*******************************************************************************
TRIGGER INJURY ARCHIVE SEARCH
Triggers a player search.
*******************************************************************************/

import clearInjuryArchiveSearch from './clear-injury-archive-search';
import searchInjuryArchive from './injury-archive-search';

export default async function triggerInjuryArchiveSearch(e) {

    const $input = $(e.currentTarget);
    const searchTerm = $input.val();

    // Get the data attributes
    const dates = $input.data('dates') || '';
    const injury = $input.data('injury') || '';
    const lastSearch = $input.data('lastsearch') || '';

    // If the input is empty or the ESC key is pressed,
    // then reset everything to its initial state and exit out
    if (!searchTerm || e.which === 27) { clearInjuryArchiveSearch(); return; }

    // If the last search is the same as the current search, don't run it again
    if (searchTerm === lastSearch) { return; }

    // The container for the search results
    const $searchResults = $('.archive-search-results');

    // Display a message and exit out if there are fewer than 2 characters
    $searchResults.removeClass('hide').html('<li>Please enter at least 2 characters.</li>');
    if (searchTerm.length < 2) { return; }

    // Empty the search results and add a "Searching..." message
    $searchResults.empty().html('<li>Searching for players...</li>');

    // Set the data that gets used with the AJAX query
    const settings = {
        searchTerm,
    };

    try {
        // Store the current search term in a data attribute (useful for preventing duplicate AJAX calls)
        $input.data('lastsearch', searchTerm);

        // Search the players
        // If players is undefined, the rest of this try block won't run
        const { players } = await searchInjuryArchive(settings);

        // If there are no results, exit out and show the empty state
        if (players.length === 0) {
            $searchResults.html('<li class="empty">No players matched your search.</li>');
            return;
        }

        let resultsHTML = '';
        players.forEach((player) => {

            resultsHTML += `
            <li data-pid="${player.id}">
                <div class="flex-row align-center full-width flex-wrap word-wrap">
                    <div class="md-text" style="margin-left:5px;">${player.name}</div>&nbsp;
                    <div class="sm-text pad-0-5">${player.team}&nbsp&nbsp${player.position}</div>
                </div>
                <a href="/basketball/injury-archive.php?injury=${injury}&dates=${dates}&player=${player.id}" class="btn size-1 primary">Select</a>
            </li>`;
        });

        // Add the search results to their container
        $searchResults.safehtml(resultsHTML);
    }
    catch (err) {
        // Error message already triggered in search-players.js
    }
}
